import * as React from 'react';
import sortBy from 'sort-by';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { ColumnDef, Row } from '@tanstack/react-table';
import { TanstackTable } from 'Shared/Components/Mui/TanstackTable/index';
import RegisterStructure from 'Shared/Constant/HomeTargetsAssociate/RecordStructure';
import { IHomeTargetsSupplier } from 'Module/HomeUser/Interface/HomeTargetsSupplier';
import { IFieldStructure } from 'Shared/Interfaces/ObjectSalesforce';
import { Box, Grid, LinearProgress, Typography } from '@mui/material';
import { ISuppliersReportPage } from 'Module/SuppliersReport/Interface';
import { KEY_HOMETARGETSSUPPLIER_SELECTED } from 'Shared/Constant/Cache';
import * as XLSX from 'xlsx';

function PaperComponent(props: PaperProps) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
}

export default function SuppliersReportAssociateModalPage(props: ISuppliersReportPage) {
  const [open] = React.useState(true);
  const [isExporting, setIsExporting] = React.useState<boolean>(false);

  const [columns, setColumns] = React.useState<ColumnDef<object, any>[]>([]);
  const toggleSetColumns = (values: ColumnDef<object, any>[]) => {
    setColumns(values);
  }

  const [data, setData] = React.useState<object[]>([]);
  const toggleSetData = (values: [IHomeTargetsSupplier?]) => {
    const _array: object[] = values.map(reg => reg || {});
    setData(_array);
  }

  const toggleSetItemSelected = (item: IHomeTargetsSupplier) => {
    const _regAux: IHomeTargetsSupplier = item;
    const _item: IHomeTargetsSupplier = {
      id: _regAux.id,
      codigo: _regAux.codigo,
      nome: _regAux.nome,
      documento: _regAux.documento,

      codigoFornec: _regAux.codigoFornec,
      documentFornec: _regAux.documentFornec,
      nomeFornec: _regAux.nomeFornec,

      valorBase: _regAux.valorBase,
      qtdeBase: _regAux.qtdeBase,

      metaMix: _regAux.metaMix,
      mix: _regAux.mix,
      percentMix: _regAux.percentMix,

      metaFaturamento: _regAux.metaFaturamento,
      faturamento: _regAux.faturamento,
      percentFaturmento: _regAux.percentFaturmento,

      criadoEm: _regAux.criadoEm,
      alteradoEm: _regAux.alteradoEm,
    };

    if (props.toggleSetTargetSupplierSelected) {
      props.toggleSetTargetSupplierSelected(_item);
    }
    if (props.toggleSetCache) {
      props.toggleSetCache(KEY_HOMETARGETSSUPPLIER_SELECTED, _item);
    }

    if (props.toggleShowModalAssociateProductDetail) {
      props.toggleShowModalAssociateProductDetail(true);
    }
  }

  const getFieldsStructure = React.useCallback((list: IFieldStructure[]) => {
    const _array: ColumnDef<object, any>[] = [];
    if (list && list.length > 0) {
      for (let regField of list.sort(sortBy('orderFormMain'))) {
        let _column: ColumnDef<object, any> | null = null;
        if (regField.viewFormMain && regField.nameField) {
          switch (regField.type) {
            case 'checkbox':
              _column = {
                id: regField.nameField,
                accessorKey: regField.nameField,
                header: regField.label,
                cell: ({ row }) => {
                  const rowData = row.original as any;
                  if (regField.nameField === 'active') {
                    return (<input type="checkbox" checked={rowData.active} readOnly />);
                  }
                  if (regField.nameField === 'isMeta') {
                    return (<input type="checkbox" checked={rowData.isMeta} readOnly />);
                  }
                  return (<input type="checkbox" checked={Boolean(row.getValue(regField.nameField!))} readOnly />);
                },
              };
              break;
            case 'currency':
              _column = {
                id: regField.nameField!,
                accessorKey: regField.nameField!,
                header: regField.label,
                meta: {
                  align: 'right',
                },
              };
              break;
            default:
              _column = {
                id: regField.nameField!,
                accessorKey: regField.nameField!,
                header: regField.label,
              };
              break;
          }
          if (!_column || regField.hiddenFormMain) {
            continue;
          }
          if (regField.width || regField.cellStyle) {
            _column.meta = {
              ...(typeof _column.meta === 'object' ? _column.meta : {}),
              cellSx: regField.cellStyle,
              headerSx: regField.width ? { width: regField.width } : undefined,
            };
          }

          switch (regField.nameField) {
            case 'qtCxFaturada':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'vlrVenda':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'valorBase':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              // _column.render = (rowData: any) => parseFloat(rowData.valorBase.replace(/\./g, '').replace(/,/g, '.')).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', currencyDisplay: 'narrowSymbol' }).replace('R$', ''); // Formata o número no formato pt-br sem moeda
              break;
            case 'qtdeBase':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'metaMix':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'mix':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'percentMix':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'metaFaturamento':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'faturamento':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'percentFaturmento':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'caixas':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'qtUnitCx':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            case 'vlrUnitario':
              _column.sortingFn = (rowA, rowB, columnId) => {
                const first = String(rowA.getValue(columnId) ?? '0');
                const second = String(rowB.getValue(columnId) ?? '0');
                return parseFloat(first.replace(/\./g, '').replace(/,/g, '.'))
                  - parseFloat(second.replace(/\./g, '').replace(/,/g, '.'));
              };
              break;
            default:
              break;
          }


          _array.push(_column)
        }
      }
    }
    toggleSetColumns(_array);

  }, [])

  const exportDataToExcel = (data: any[], fileName: string, sheetName: string = 'Sheet1') => {
    // Cria uma planilha a partir dos dados
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Cria um workbook e adiciona a planilha
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    // Gera o arquivo Excel e faz o download
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  }
  // Função para exportar os dados para Excel
  const handleExportToExcel = () => {
    setIsExporting(true);
    try {
      if (data && data.length > 0) {
        const formattedData = data.map((item: any) => {
          const formattedItem: any = {
            nomeFornec: item.nomeFornec,
            codigo: item.codigo,
            nome: item.nome,
            documento: item.documento,
            metaMix: item.metaMix,
            mix: item.mix,
            percentMix: item.percentMix,
            metaFaturamento: item.metaFaturamento,
            faturamento: item.faturamento,
            percentFaturmento: item.percentFaturmento,
          };

          return formattedItem;
        });
        exportDataToExcel(formattedData, `Relatorio_${props?.titleModalTargetsAssociate}`.replace(/ /g, '_'), `Relatorio_${props?.titleModalTargetsAssociate}`.replace(/ /g, '_'));
      }
      else {
        console.error('Nenhum dado para exportar.');
      }
    } finally {
      setTimeout(() => setIsExporting(false), 300);
    }
  }


  const handleClose = () => {
    if (props.toggleShowModalAssociateDetail) {
      props.toggleShowModalAssociateDetail(false);
    }
  };

  React.useEffect(() => {
    getFieldsStructure(RegisterStructure);
    toggleSetData(props?.listModalTargetsAssociate || []);
  }, [props.listModalTargetsAssociate, props.dateUpdateInfo, getFieldsStructure])

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Grid container spacing={1}>
            <Grid item xs={6} sm={8} md={9} lg={10} xl={10}>
              <Typography component={'div'} align='left'>
                <span className='AssociatesReportModalTitle'>{props?.titleModalTargetsAssociate || 'Metas'}</span>
                {props.showLoadingUpdateTable && (
                  <Box component="span" sx={{ display: 'inline-flex', width: 120 }}>
                    <LinearProgress />
                  </Box>
                )}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4} md={3} lg={2} xl={2}>
              <Typography component={'div'} align='right'>
                <Button
                  variant="contained"
                  color="success"
                  className="ButtonDanger"
                  type="button"
                  autoFocus
                  onClick={handleClose}
                >
                  <span>Fechar</span>
                </Button>
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component={'div'}>
            <Typography component={'div'} align='left' className='divDefaultEmpty'>
              <Button
                variant="contained"
                color="warning"
                className="ButtonPrimary"
                type="button"
                autoFocus
                onClick={handleExportToExcel}
                disabled={isExporting}
              >
                <span>Exportar Excel</span>
              </Button>
              {isExporting && (
                <Box mt={1}>
                  <LinearProgress />
                </Box>
              )}
            </Typography>
            <Typography component={'div'} align='left' className='divDefaultEmpty'>
              <TanstackTable
                data={data}
                columns={columns}
                title="Metas associados"
                isLoading={props.showLoadingThisPage}
                enableGlobalFilter
                stickyHeader
                onRowClick={(row: Row<object>) =>
                  toggleSetItemSelected(row.original as IHomeTargetsSupplier)
                }
                rowsPerPageOptions={[5, 10, 20, 50]}
              />
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
    </div>
  );
}
